import { render, staticRenderFns } from "./LeftContent.vue?vue&type=template&id=40ecb42b&scoped=true&"
import script from "./LeftContent.vue?vue&type=script&lang=js&"
export * from "./LeftContent.vue?vue&type=script&lang=js&"
import style0 from "./LeftContent.vue?vue&type=style&index=0&id=40ecb42b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecb42b",
  null
  
)

export default component.exports